import Swiper, {
  Autoplay, Lazy, Thumbs, Navigation,
} from 'swiper';

Swiper.use([Lazy, Autoplay, Thumbs, Navigation]);
// Swiper configurations

const featuresSwiperConfig = {
  direction: 'horizontal',
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1025: {
      slidesPerView: 3.4,
      spaceBetween: 40,
    },
    768: {
      slidesPerView: 2.2,
      spaceBetween: 40,
    },
    320: {
      slidesPerView: 1.18,
      spaceBetween: 20,
    },
  },
};

const imageSwiperConfig = {
  direction: 'horizontal',
  lazy: {
    loadOnTransitionStart: true,
    checkInView: true,
  },
  autoplay: {
    delay: 7000,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1025: {
      slidesPerView: 3.1,
      spaceBetween: 40,
    },
    750: {
      slidesPerView: 2.2,
      spaceBetween: 20,
    },
    320: {
      slidesPerView: 1.2,
      spaceBetween: 20,
    },
  },
};

const appSwiperConfig = {
  direction: 'horizontal',
  lazy: {
    loadOnTransitionStart: true,
    checkInView: true,
  },
  autoplay: {
    delay: 7000,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 24,
    },
    320: {
      slidesPerView: 1.2,
      spaceBetween: 32,
    },
  },
};

const introSectionSwiperConfig = {
  direction: 'horizontal',
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1025: {
      slidesPerView: 3,
      spaceBetween: 40,
      enabled: false,
    },
    750: {
      slidesPerView: 2.3,
      spaceBetween: 40,
    },
    320: {
      slidesPerView: 1.12,
      spaceBetween: 20,
      enabled: true,
    },
  },
};

const statsSwiperConfig = {
  direction: 'horizontal',
  autoplay: {
    delay: 7000,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  // Desktop stays plain slidesPerView/spaceBetween (no loop) — matches
  // imageSwiperConfig's shape there, which is what resizes cleanly across
  // the 1025px boundary without a reload. Tablet/mobile add loop +
  // centeredSlides so the active card peeks both neighbors per the design;
  // scoped to just these breakpoints so desktop never sees the loop clones.
  breakpoints: {
    1025: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
    750: {
      slidesPerView: 2.3,
      spaceBetween: 40,
    },
    320: {
      slidesPerView: 1.12,
      spaceBetween: 20,
      centeredSlides: true,
    },
  },
};

const reviewsSwiperConfig = {
  direction: 'horizontal',
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1025: {
      slidesPerView: 3.4,
      spaceBetween: 40,
    },
    768: {
      slidesPerView: 2.2,
      spaceBetween: 40,
    },
    320: {
      slidesPerView: 1.13,
      enabled: false,
    },
  },
};

const verticalSwiperConfig = {
  direction: 'horizontal',
  loop: true,
  lazy: {
    loadOnTransitionStart: true,
    checkInView: true,
  },
  autoplay: {
    delay: 8000,
  },
  slidesPerView: 1,
  spaceBetween: 24,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};
/*---------------------------------------------------------------*/

function appSwiperActive(slides) {
  const swiperItems = document.querySelectorAll('.slider-howItWorks .slider-content');
  slides.on('transitionStart', () => {
    const activeSlideIndex = document.querySelector('#appSwiper .swiper-slide-active').getAttribute('data-slide-index');
    swiperItems.forEach((activeItem) => {
      if (activeItem) {
        if (activeItem.getAttribute('data-slide') === activeSlideIndex) {
          activeItem.classList.add('active');
        } else {
          activeItem.classList.remove('active');
        }
      }
    });
  });
  // click funtionality
  swiperItems.forEach((activeItem) => {
    activeItem.addEventListener('click', (event) => {
      slides.slideTo(parseInt(event.target.parentNode.dataset.slide, 10) - 1, 300);
    });
  });
}

// Initialise swiper

function initSlider() {
  if (document.getElementById('featuresSwiper')) {
    const featuresSwiper = new Swiper('#featuresSwiper', featuresSwiperConfig);
    console.info(`${featuresSwiper}initiated`);
  }

  if (document.getElementById('imageSwiper')) {
    const imageSwiper = new Swiper('#imageSwiper', imageSwiperConfig);
    imageSwiper.on('click', (e) => {
      const toLoad = +e.activeIndex + 4;
      imageSwiper.lazy.loadInSlide(toLoad);
    });
    imageSwiper.lazy.loadInSlide(3);
    console.info(`${imageSwiper}initiated`);
  }

  if (document.getElementById('appSwiper')) {
    const appSwiper = new Swiper('#appSwiper', appSwiperConfig);
    console.info(`${appSwiper}initiated`);
    appSwiperActive(appSwiper);
  }

  if (document.getElementById('introSectionSwiper')) {
    const introSectionSwiper = new Swiper('#introSectionSwiper', introSectionSwiperConfig);
    console.info(`${introSectionSwiper}initiated`);
  }

  if (document.getElementById('statsSwiper')) {
    const statsSwiper = new Swiper('#statsSwiper', statsSwiperConfig);
    // centeredSlides only applies at the 320 breakpoint — crossing into/out
    // of it live (e.g. resizing the window, not just a DevTools reload)
    // can leave the track translated as if still centered. Re-snapping to
    // the current slide on every breakpoint change forces a clean recalc.
    statsSwiper.on('breakpoint', () => statsSwiper.slideTo(statsSwiper.activeIndex, 0));
    console.info(`${statsSwiper}initiated`);
  }

  if (document.getElementById('reviewsSwiper')) {
    const reviewsSwiper = new Swiper('#reviewsSwiper', reviewsSwiperConfig);
    console.info(`${reviewsSwiper}initiated`);
  }
}

if (window.innerWidth > 1024) {
  const section = document.querySelector('#verticalSlider');
  if (section) {
    const imgHolder = document.querySelector('.preview-holder');
    const sliderImages = imgHolder.querySelectorAll('.slider-picture');
    const sliderContents = [...document.querySelectorAll('.slider__vertical--content')];

    const activateImg = (act) => {
      Array.from(sliderImages).forEach((img, i) => {
        const sliderContent = sliderContents[i];
        if (img && sliderContent) {
          if (i !== act) {
            img.classList.remove('active');
            sliderContent.classList.remove('active');
          } else if (i === act) {
            img.classList.add('active');
            sliderContent.classList.add('active');
          }
        }
      });
    };
    activateImg(0);

    const previewScrollStyles = (position, top, bottom) => {
      if (typeof top === 'string' && typeof bottom === 'string') {
        imgHolder.style.top = top;
        imgHolder.style.bottom = bottom;
        imgHolder.style.position = position;
      } else {
        console.error(`The top:${top} and bottom:${bottom} value should be string`);
      }
    };

    const fixPreview = () => {
      const firstContent = sliderContents[0].clientHeight;
      const imageHolderHeight = imgHolder.clientHeight;
      const verticalSliderSection = section.getBoundingClientRect();
      const previewFixValue = Math.floor((window.innerHeight / 2) / 2);
      if (verticalSliderSection.bottom < imageHolderHeight + previewFixValue) {
        previewScrollStyles('absolute', 'unset', '0');
      } else if (verticalSliderSection.top > previewFixValue) {
        previewScrollStyles('absolute', '0', 'unset');
      } else if (verticalSliderSection.top < previewFixValue
      && verticalSliderSection.bottom > imageHolderHeight + previewFixValue) {
        previewScrollStyles('fixed', `${previewFixValue}px`, 'unset');

        Array.from(sliderContents).forEach((_, i) => {
          if (
            (i === 0 && -verticalSliderSection.top < firstContent * 1)
                  || (-verticalSliderSection.top > firstContent * (i - 1)
                  && -verticalSliderSection.top < firstContent * i)
                  || (-verticalSliderSection.top > firstContent * (i + 1)
                  && -verticalSliderSection.top < firstContent * (i + 1))
          ) {
            activateImg(i);
          }
        });
      }
    };

    window.addEventListener('scroll', () => {
      fixPreview();
    });
  }
} else if (document.getElementById('verticalSwiperMobile')) {
  document.querySelector('#verticalSwiperMobile > ul').classList.add('swiper-wrapper');
  const verticalSwiper = new Swiper('#verticalSwiperMobile', verticalSwiperConfig);
  console.info(`${verticalSwiper} initiated`);
}

initSlider();
